import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["restaurantFields", "personalGuaranteeNotice"]
  
  connect() {
    this.checkInitialState()
  }
  
  checkInitialState() {
    // Check restaurant fields - try both form naming conventions
    const industrySelect = this.element.querySelector('select[name="loan_application[industry]"]') || 
                           this.element.querySelector('select[name="application[industry]"]')
    if (industrySelect) {
      this.toggleRestaurantFields({ target: industrySelect })
    }
    
    // Check personal guarantee - try both form naming conventions
    const yearsInput = this.element.querySelector('input[name="loan_application[years_in_business]"]') || 
                       this.element.querySelector('input[name="application[years_in_business]"]')
    if (yearsInput) {
      this.checkPersonalGuarantee({ target: yearsInput })
    }
  }
  
  toggleRestaurantFields(event) {
    const industryValue = event.target.value
    const restaurantFields = document.getElementById('restaurant-fields')
    
    if (restaurantFields) {
      if (industryValue === 'Restaurant') {
        restaurantFields.classList.remove('hidden')
      } else {
        restaurantFields.classList.add('hidden')
        // Clear restaurant-specific fields when hidden
        const liquorLicenseInputs = restaurantFields.querySelectorAll('input[name="loan_application[liquor_license]"]')
        liquorLicenseInputs.forEach(input => input.checked = false)
        
        const seatingCapacityInput = restaurantFields.querySelector('input[name="loan_application[seating_capacity]"]')
        if (seatingCapacityInput) seatingCapacityInput.value = ''
      }
    }
  }
  
  checkPersonalGuarantee(event) {
    const years = parseFloat(event.target.value) || 0
    const guaranteeNotice = document.getElementById('personal-guarantee-notice')
    
    if (guaranteeNotice) {
      if (years < 2 && years > 0) {
        guaranteeNotice.classList.remove('hidden')
      } else {
        guaranteeNotice.classList.add('hidden')
      }
    }
  }
  
  formatEIN(event) {
    let value = event.target.value.replace(/\D/g, '') // Remove non-digits
    
    if (value.length >= 2) {
      value = value.substring(0, 2) + '-' + value.substring(2, 9)
    }
    
    event.target.value = value
  }
}